// import FMLLogo from '../assets/images/logo-FML.svg'
import myfxLogo from '../assets/images/myfxLogo.svg'
// import FalchionLog from '../assets/images/logo-icon.svg'
const Logos = () => {
    return (

        <div className="border d-inline-flex border-secondary rounded-3 p-2 gap-3 border-opacity-50">
            <img src={myfxLogo} alt="Falchion Logo" width={40} />
            {/* <img src={FMLLogo} alt="FML Logo" width={40} /> */}
        </div>
    );
};

export default Logos;
